window.addEventListener('load', () => {
    const bgInner = document.querySelector('.bg-inner');
    if (bgInner) {
        bgInner.style.opacity = '1';
    }
});

window.addEventListener('resize', () => {

});